module.exports = __webpack_public_path__ + "img/theater_round_11.76bc487a.png";